import { render, staticRenderFns } from "./TopCustomers.vue?vue&type=template&id=6ce175e2&scoped=true&"
import script from "./TopCustomers.vue?vue&type=script&lang=js&"
export * from "./TopCustomers.vue?vue&type=script&lang=js&"
import style0 from "./TopCustomers.vue?vue&type=style&index=0&id=6ce175e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce175e2",
  null
  
)

export default component.exports